'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _pravniFormyActions = require('./../actions/pravniFormy-actions');

var PravniFormyActions = _interopRequireWildcard(_pravniFormyActions);

var _utils = require('./../utils');

var _Utils = require('./../Utils2');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getArea(props) {
    return props.area ? props.area : "shared.pravniFormy";
}

// TODO StoreSuggest
/**
 * Právní forma field
 * Suggest
 */

var PravniFormaField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(PravniFormaField, _AbstractReactCompone);

    function PravniFormaField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PravniFormaField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PravniFormaField.__proto__ || (0, _getPrototypeOf2.default)(PravniFormaField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            var pravniFormy = _this.props.pravniFormy;


            return new _promise2.default(function (resolve, reject) {
                if (pravniFormy.fetched) {
                    var rows = (0, _utils.filterObjectsByPropertyFulltext)(pravniFormy.rows, value, "nazev");
                    resolve(rows);
                } else {
                    resolve([]);
                }
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PravniFormaField, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var area = getArea(this.props);
            this.dispatch(PravniFormyActions.fetchListIfNeeded(area));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                pravniFormy = _props.pravniFormy,
                other = (0, _objectWithoutProperties3.default)(_props, ['pravniFormy']);


            if (!pravniFormy || !pravniFormy.fetched) {
                return _react2.default.createElement(_reactstrap.Input, {
                    type: 'text',
                    disabled: true
                });
            }

            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                filterSuggestions: this.handleFilterSuggestions,
                apiRequestDelay: 0,
                getItemValue: function getItemValue(item) {
                    return item ? item.nazev : "";
                },
                renderSuggestion: function renderSuggestion(i, active, getItemValue) {
                    return _react2.default.createElement(
                        'div',
                        {
                            className: active ? "active" : "" },
                        i.nazev
                    );
                }
            }, other));
        }
    }]);
    return PravniFormaField;
}(_AbstractReactComponent2.default);

PravniFormaField.PropTypes = {
    pravniFormy: _react2.default.PropTypes.object, // není required kvůli shared store, který nemusí být inicializovaný
    area: _react2.default.PropTypes.string,
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};


function mapStateToProps(state, props) {
    var useArea = getArea(props);
    var pravniFormyStore = (0, _utils.storeFromArea)(state, useArea, false);

    return {
        pravniFormy: pravniFormyStore
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PravniFormaField);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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